import React from "react";
import { Modal } from "antd";
import { DeleteOutlined} from "@ant-design/icons";

const DeleteConfirm = (props) => {
  const onDelete = async (values) => {
    props?.confirmDelete(values)
  }
  return (
    <DeleteOutlined
      onClick={() => {
        Modal.confirm({
          title: `${props?.title}`,
          content: `Are you sure you want to delete ${props?.title}`,
          icon: <DeleteOutlined />,
          cancelText:"Cancel",
          okText: "Delete",
          onOk: ()=>onDelete(props?.ID),
        });
      }}
    />
  );
};

export default DeleteConfirm;